module.exports = __webpack_public_path__ + "media/Register_by_CC.e31600b8.mp4";